module.exports = __webpack_public_path__ + "static/media/desktop-modal-es.a6edb26a.png";